import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperContent } from 'vuetify/lib/components/VStepper';
import { VStepperHeader } from 'vuetify/lib/components/VStepper';
import { VStepperItems } from 'vuetify/lib/components/VStepper';
import { VStepperStep } from 'vuetify/lib/components/VStepper';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(VContainer,[_c(VStepper,{model:{value:(_vm.e2),callback:function ($$v) {_vm.e2=$$v},expression:"e2"}},[_c(VStepperHeader,[_c(VStepperStep,{attrs:{"complete":_vm.e2 > 1,"step":"1"}},[_vm._v(" Informations personnel ")]),_c(VDivider),_c(VStepperStep,{attrs:{"complete":_vm.e2 > 2,"step":"2"}},[_vm._v(" Informations supplementaire ")]),_c(VDivider),_c(VStepperStep,{attrs:{"step":"3"}},[_vm._v(" Resumé ")])],1),_c(VForm,{staticClass:"multi-col-validation"},[_c(VStepperItems,[_c(VStepperContent,{attrs:{"step":"1"}},[_c(VRow,{staticStyle:{"margin-top":"1%"}},[_c(VCol,{attrs:{"cols":"12","md":"6"}},[_c(VSelect,{attrs:{"dense":"","items":['M.', 'Mme', 'Mle'],"label":"Civilite","outlined":""},model:{value:(_vm.customer.cust_sexe),callback:function ($$v) {_vm.$set(_vm.customer, "cust_sexe", $$v)},expression:"customer.cust_sexe"}})],1),_c(VCol,{attrs:{"cols":"12","md":"6"}},[_c(VTextField,{attrs:{"dense":"","required":"","hide-details":"","label":"Nom","outlined":"","placeholder":"Nom"},model:{value:(_vm.customer.cust_lastname),callback:function ($$v) {_vm.$set(_vm.customer, "cust_lastname", $$v)},expression:"customer.cust_lastname"}})],1),_c(VCol,{attrs:{"cols":"12","md":"6"}},[_c(VTextField,{attrs:{"dense":"","hide-details":"","required":"","label":"Prénom","outlined":"","placeholder":"Prénom"},model:{value:(_vm.customer.cust_firstname),callback:function ($$v) {_vm.$set(_vm.customer, "cust_firstname", $$v)},expression:"customer.cust_firstname"}})],1),_c(VCol,{attrs:{"cols":"12","md":"6"}},[_c(VTextField,{attrs:{"dense":"","type":"date","hide-details":"","label":"Date d'anniversaire","outlined":"","placeholder":"date de naissance"},model:{value:(_vm.customer.cust_birthday),callback:function ($$v) {_vm.$set(_vm.customer, "cust_birthday", $$v)},expression:"customer.cust_birthday"}})],1),_c(VCol,{attrs:{"cols":"12","md":"6"}},[_c(VTextField,{attrs:{"dense":"","hide-details":"","label":"Lieu de Naissance","outlined":"","placeholder":"lieu de Naissance"},model:{value:(_vm.customer.cust_birth_place),callback:function ($$v) {_vm.$set(_vm.customer, "cust_birth_place", $$v)},expression:"customer.cust_birth_place"}})],1),_c(VCol,{attrs:{"cols":"12","md":"6"}},[_c(VSelect,{attrs:{"dense":"","items":['Carte Nationale d\'Identite(CNI)', 'Permis de conduire','Passeport','Carte consulaire'],"label":"Type de piece d'identite","outlined":""},model:{value:(_vm.customer.cust_type_id),callback:function ($$v) {_vm.$set(_vm.customer, "cust_type_id", $$v)},expression:"customer.cust_type_id"}})],1),_c(VCol,{attrs:{"cols":"12","md":"6"}},[_c(VTextField,{attrs:{"dense":"","hide-details":"","label":"Reference de la piece","outlined":"","placeholder":"Reference"},model:{value:(_vm.customer.cust_reference_id),callback:function ($$v) {_vm.$set(_vm.customer, "cust_reference_id", $$v)},expression:"customer.cust_reference_id"}})],1),_c(VCol,{attrs:{"cols":"12","md":"6"}},[_c(VTextField,{attrs:{"type":"date","dense":"","hide-details":"","label":"Date d'expiration de la piece","outlined":""},model:{value:(_vm.customer.cust_id_expiration_date),callback:function ($$v) {_vm.$set(_vm.customer, "cust_id_expiration_date", $$v)},expression:"customer.cust_id_expiration_date"}})],1),_c(VCol,{attrs:{"cols":"12","md":"6"}},[_c(VTextField,{attrs:{"dense":"","hide-details":"","label":"Contact","outlined":"","placeholder":"numero de telephone"},model:{value:(_vm.customer.cust_contact),callback:function ($$v) {_vm.$set(_vm.customer, "cust_contact", $$v)},expression:"customer.cust_contact"}})],1),_c(VCol,{attrs:{"cols":"12","md":"6"}},[_c(VTextField,{attrs:{"dense":"","hide-details":"","label":"Lieu de residence","outlined":"","placeholder":"Domicile"},model:{value:(_vm.customer.cust_place_residence),callback:function ($$v) {_vm.$set(_vm.customer, "cust_place_residence", $$v)},expression:"customer.cust_place_residence"}})],1)],1),_c(VRow,[_c(VCol,{attrs:{"cols":"12","md":"6"}},[_c(VBtn,{attrs:{"color":"primary"},on:{"click":function($event){_vm.e2 = 1}}},[_vm._v(" Precedent ")])],1),_c(VCol,{attrs:{"cols":"12","md":"6"}},[_c(VBtn,{staticStyle:{"margin-left":"1rem","margin-right":"1rem"},attrs:{"color":"primary"},on:{"click":function($event){_vm.e2 = 2}}},[_vm._v(" Continuer ")])],1)],1)],1),_c(VStepperContent,{attrs:{"step":"2"}},[_c(VRow,[_c(VCol,{attrs:{"cols":"12","md":"6"}},[_c(VTextField,{attrs:{"dense":"","hide-details":"","label":"Non de la mere","outlined":"","placeholder":"Non complet"},model:{value:(_vm.customer.cust_mother_name),callback:function ($$v) {_vm.$set(_vm.customer, "cust_mother_name", $$v)},expression:"customer.cust_mother_name"}})],1),_c(VCol,{attrs:{"cols":"12","md":"6"}},[_c(VTextField,{attrs:{"dense":"","hide-details":"","label":"Non du pere","outlined":"","placeholder":"Nom complet"},model:{value:(_vm.customer.cust_father_name),callback:function ($$v) {_vm.$set(_vm.customer, "cust_father_name", $$v)},expression:"customer.cust_father_name"}})],1),_c(VCol,{attrs:{"cols":"12","md":"6"}},[_c(VTextField,{attrs:{"dense":"","hide-details":"","label":"Profession","outlined":"","placeholder":"metier"},model:{value:(_vm.customer.cust_job),callback:function ($$v) {_vm.$set(_vm.customer, "cust_job", $$v)},expression:"customer.cust_job"}})],1),_c(VCol,{attrs:{"cols":"12","md":"6"}},[_c(VTextField,{attrs:{"type":"email","dense":"","label":"Addresse Email","outlined":""},model:{value:(_vm.customer.cust_email),callback:function ($$v) {_vm.$set(_vm.customer, "cust_email", $$v)},expression:"customer.cust_email"}})],1),_c(VCol,{attrs:{"cols":"12","md":"6"}},[_c(VTextField,{attrs:{"dense":"","hide-details":"","label":"Pseudonyme","outlined":"","placeholder":"nom de carresse"},model:{value:(_vm.customer.cust_pseudonym),callback:function ($$v) {_vm.$set(_vm.customer, "cust_pseudonym", $$v)},expression:"customer.cust_pseudonym"}})],1),_c(VCol,{attrs:{"cols":"12","md":"6"}},[_c(VSelect,{attrs:{"dense":"","name":"room","item-text":'name',"item-value":'id',"items":[
                   "Française",
                  "Ivoirienne",
                  "Suisse",
                  "Belge",
                  "Allemande",
                  "Italienne",
                  "Afghane",
                  "Albanaise",
                  "Algerienne",
                  "Americaine",
                  "Andorrane",
                  "Angolaise",
                  "Antiguaise et barbudienne",
                  "Argentine",
                  "Armenienne",
                  "Australienne",
                  "Autrichienne",
                  "Azerbaïdjanaise",
                  "Bahamienne",
                  "Bahreinienne",
                  "Bangladaise",
                  "Barbadienne",
                  "Belizienne",
                  "Beninoise",
                  "Bhoutanaise",
                  "Bielorusse",
                  "Birmane",
                  "Bissau-Guinéenne",
                  "Bolivienne",
                  "Bosnienne",
                  "Botswanaise",
                  "Bresilienne",
                  "Britannique",
                  "Bruneienne",
                  "Bulgare",
                  "Burkinabe",
                  "Burundaise",
                  "Cambodgienne",
                  "Camerounaise",
                  "Canadienne",
                  "Cap-verdienne",
                  "Centrafricaine",
                  "Chilienne",
                  "Chinoise",
                  "Chypriote",
                  "Colombienne",
                  "Comorienne",
                  "Congolaise",
                  "Costaricaine",
                  "Croate",
                  "Cubaine",
                  "Curaçaoane",
                  "Danoise",
                  "Djiboutienne",
                  "Dominicaine",
                  "Dominiquaise",
                  "Egyptienne",
                  "Emirienne",
                  "Equato-guineenne",
                  "Equatorienne",
                  "Erythreenne",
                  "Espagnole",
                  "Est-timoraise",
                  "Estonienne",
                  "Ethiopienne",
                  "Fidjienne",
                  "Finlandaise",
                  "Gabonaise",
                  "Gambienne",
                  "Georgienne",
                  "Ghaneenne",
                  "Grenadienne",
                  "Guatemalteque",
                  "Guineenne",
                  "Guyanienne",
                  "Haïtienne",
                  "Hellenique",
                  "Hondurienne",
                  "Hongroise",
                  "Indienne",
                  "Indonesienne",
                  "Irakienne",
                  "Irlandaise",
                  "Islandaise",
                  "Israélienne",
                  "Jamaïcaine",
                  "Japonaise",
                  "Jordanienne",
                  "Kazakhstanaise",
                  "Kenyane",
                  "Kirghize",
                  "Kiribatienne",
                  "Kittitienne-et-nevicienne",
                  "Kossovienne",
                  "Koweitienne",
                  "Laotienne",
                  "Lesothane",
                  "Lettone",
                  "Libanaise",
                  "Liberienne",
                  "Libyenne",
                  "Liechtensteinoise",
                  "Lituanienne",
                  "Luxembourgeoise",
                  "Macedonienne",
                  "Malaisienne",
                  "Malawienne",
                  "Maldivienne",
                  "Malgache",
                  "Malienne",
                  "Maltaise",
                  "Marocaine",
                  "Marshallaise",
                  "Mauricienne",
                  "Mauritanienne",
                  "Mexicaine",
                  "Micronesienne",
                  "Moldave",
                  "Monegasque",
                  "Mongole",
                  "Montenegrine",
                  "Mozambicaine",
                  "Namibienne",
                  "Nauruane",
                  "Neerlandaise",
                  "Neo-zelandaise",
                  "Nepalaise",
                  "Nicaraguayenne",
                  "Nigeriane",
                  "Nigerienne",
                  "Nord-coréenne",
                  "Norvegienne",
                  "Omanaise",
                  "Ougandaise",
                  "Ouzbeke",
                  "Pakistanaise",
                  "Palau",
                  "Palestinienne",
                  "Panameenne",
                  "Papouane-neoguineenne",
                  "Paraguayenne",
                  "Peruvienne",
                  "Philippine",
                  "Polonaise",
                  "Portoricaine",
                  "Portugaise",
                  "Qatarienne",
                  "Roumaine",
                  "Russe",
                  "Rwandaise",
                  "Saint-Lucienne",
                  "Saint-Marinaise",
                  "Saint-Martinoise",
                  "Saint-Vincentaise-et-Grenadine",
                  "Salomonaise",
                  "Salvadorienne",
                  "Samoane",
                  "Santomeenne",
                  "Saoudienne",
                  "Senegalaise",
                  "Sud-Soudanaise",
                  "Serbe",
                  "Seychelloise",
                  "Sierra-leonaise",
                  "Singapourienne",
                  "Slovaque",
                  "Slovene",
                  "Somalienne",
                  "Soudanaise",
                  "Sri-lankaise",
                  "Sud-africaine",
                  "Sud-coréenne",
                  "Suedoise",
                  "Surinamaise",
                  "Swazie",
                  "Syrienne",
                  "Tadjike",
                  "Taiwanaise",
                  "Tanzanienne",
                  "Tchadienne",
                  "Tcheque",
                  "Thaïlandaise",
                  "Togolaise",
                  "Tonguienne",
                  "Trinidadienne",
                  "Tunisienne",
                  "Turkmene",
                  "Turque",
                  "Tuvaluane",
                  "Ukrainienne",
                  "Uruguayenne",
                  "Vaticane",
                  "Vanuatuane",
                  "Venezuelienne",
                  "Vietnamienne",
                  "Yemenite",
                  "Zambienne",
                  "Zimbabweenne"
                  ],"label":"Nationalite","outlined":""},model:{value:(_vm.customer.cust_nationality),callback:function ($$v) {_vm.$set(_vm.customer, "cust_nationality", $$v)},expression:"customer.cust_nationality"}})],1),_c(VCol,{attrs:{"cols":"12","md":"6"}},[_c(VSelect,{attrs:{"dense":"","items":[
                        'Abidjan (District autonome)',
                         'Yamoussoukro (District autonome)',
                          'Agboville (Région de l\'Agnéby-Tiassa)',
                           'Sikensi (Région de l\'Agnéby-Tiassa)',
                          'Tiassalé (Région de l\'Agnéby-Tiassa)',
                          'Taabo (Région de l\'Agnéby-Tiassa)',
                          'Koro (Région du Bafing)',
                          'Ouaninou (Région du Bafing)',
                          'Touba (Région du Bafing)',
                          'Boundiali (Région du Bagoué)',
                          'Kouto (Région du Bagoué)',
                          'Tengréla (Région du Bagoué)',
                          'Didievi (Région du Bélier)',
                          'Tiébissou (Région du Bagoué)',
                          'Toumodi (Région du Bagoué)',
                          'Djekanou (Région du Bagoué)',
                          'Kounahiri (Région du Béré)',
                          'Mankono (Région du Béré)',
                          'Dianra (Région du Béré)',
                          'Bouna (Région de Bounkani)',
                          'Doropo (Région du Béré)',
                          'Nassian (Région du Béré)',
                          'Tehini (Région du Béré)',
                          'Bloléquin (Région du Cavally)',
                          'Guiglo (Région du Cavally)',
                          'Toulepleu (Région du Cavally)',
                          'Kaniasso (Région du Folon)',
                          'Minignan (Région du Folon)',
                           'Botro ( Région du Gbêkê)',
                           ' Bouaké ( Région du Gbêkê)',
                            'Sakassou ( Région du Gbêkê)',
                            'Fresco (Région du Gbôklé)',
                            'Sassandra (Région du Gbôklé)',
                            'Gagnoa (Région du Gôh)',
                            'Oumé (Région du Gôh)',
                            ' Bangolo (Région du Guémon)',
                             'Duékoué (Région du Guémon)',
                             'Kouibly (Région du Guémon)',
                             'Facobli (Région du Guémon)',
                             'Abengourou (Région de l\'Indénié-Djuablin)',
                             'Agnibilékrou (Région de l\'Indénié-Djuablin)',
                             ' Béttié (Région de l\'Indénié-Djuablin)',
                             'Madinani (Région du Kabadougou)',
         'Odienné (Région du Kabadougou)',
         'Gbeleban (Région du Kabadougou)',
        'Seguelon (Région du Kabadougou)',
         'Buyo (Région de la Nawa)',
         'Guéyo (Région de la Nawa)',
         'Meagui (Région de la Nawa)',
         'Soubré (Région de la Nawa)',
          'Divo (Région du Lôh-Djiboua)',
         'Guitry (Région du Lôh-Djiboua)',
         'Lakota (Région du Lôh-Djiboua)',
         'Daoukro (Région de l\'Iffou)',
          'M’Bahiakro (Région de l\'Iffou)',
          'Ouellé (Région de l\'Iffou)',
           'Prikro (Région de l\'Iffou)',
              'Arrah (Région du Moronou)',
          'Bongouanou (Région du Moronou)',
          ' M’Batto (Région du Moronou)',
            'Bocanda (Région du N\'Zi)',
         'Dimbokro (Région du N\'Zi)',
         'Kouassi-Kouassikro (Région du N\'Zi)',
          'Dabou (Région du Grands Ponts)',
         'Grand-Lahou (Région du Grands Ponts)',
         'Jacqueville (Région du Grands Ponts)',
          'Adzopé (Région de La Mé)',
         'Akoupé (Région de La Mé)',
         'Alépé (Région de La Mé)',
        ' Yakassé-Attobrou (Région de La Mé)',
          'Biankouma (Région du Tonkpi)',
         'Danané (Région du Tonkpi)',
         'Man (Région du Tonkpi)',
        'Zouan-Hounien (Région du Tonkpi)',
         'Sipilou (Région du Tonkpi)',
          'Daloa ( Région du Haut-Sassandra)',
         'Issia ( Région du Haut-Sassandra)',
         'Vavoua ( Région du Haut-Sassandra)',
        'Zoukougbeu ( Région du Haut-Sassandra)',
           'Bouaflé (Région de la Marahoué)',
         'Sinfra (Région de la Marahoué)',
        'Zuénoula (Région de la Marahoué)',
         'Bonon (Région de la Marahoué)',
             'Dikodougou (Région du Poro)',
         'Korhogo  (Région du Poro)',
         'Sinématiali (Région du Poro)',
        'M’Bengué (Région du Poro)',
         'Ferkessédougou (Région du Tchologo)',
         'Ouangolodougou (Région du Tchologo)',
         'Kong (Région du Tchologo)',
          'Dabakala (Région du Hambol)',
         'Katiola (Région du Hambol)',
          'Niakaramadougou (Région du Hambol)',
              'Bondoukou (Région du Gontougou)',
         'Koun-Fao (Région du Gontougou)',
         'Sandegue (Région du Gontougou)',
         'Tanda (Région du Gontougou)',
         'Transua (Région du Gontougou)',
          'San-Pédro (Région de San-Pédro)',
        'Tabou (Région de San-Pédro)',
             'Aboisso (Région du Sud-Comoé)',
        'Adiaké (Région du Sud-Comoé)',
         'Grand-Bassam (Région du Sud-Comoé)',
         'Tiapoum (Région du Sud-Comoé)',
             'Kani (Région du Worodougou)',
         'Séguéla (Région du Worodougou)' ],"name":"apartment","item-text":'name',"item-value":'id',"label":"Ville","outlined":""},model:{value:(_vm.customer.cust_city),callback:function ($$v) {_vm.$set(_vm.customer, "cust_city", $$v)},expression:"customer.cust_city"}})],1),_c(VCol,{attrs:{"cols":"12","md":"6"}},[_c(VSelect,{attrs:{"dense":"","items":_vm.country_wolrd,"name":"apartment","item-text":function (item) { return item[4]; },"item-value":function (item) { return item[4]; },"label":"Pays","outlined":""},model:{value:(_vm.customer.cust_country),callback:function ($$v) {_vm.$set(_vm.customer, "cust_country", $$v)},expression:"customer.cust_country"}})],1),_c(VCol,{attrs:{"cols":"12","md":"6"}},[_c(VTextField,{attrs:{"type":"date","dense":"","hide-details":"","label":"Date d'entre en cote d'ivoire","outlined":""},model:{value:(_vm.customer.cust_date_of_entering_ivory_coast),callback:function ($$v) {_vm.$set(_vm.customer, "cust_date_of_entering_ivory_coast", $$v)},expression:"customer.cust_date_of_entering_ivory_coast"}})],1)],1),_c(VRow,[_c(VCol,{attrs:{"cols":"12","md":"6"}},[_c(VBtn,{attrs:{"color":"primary"},on:{"click":function($event){_vm.e2 = 1}}},[_vm._v(" Precedent ")])],1),_c(VCol,{attrs:{"cols":"12","md":"6"}},[_c(VBtn,{staticStyle:{"margin-left":"1rem","margin-right":"1rem"},attrs:{"color":"primary"},on:{"click":function($event){_vm.e2 = 3}}},[_vm._v(" Continuer ")])],1)],1)],1),_c(VStepperContent,{attrs:{"step":"3"}},[_c(VRow,{staticStyle:{"margin-top":"3%"}},[_c(VCol,{attrs:{"cols":"12","md":"12"}},[_c(VToolbarTitle,[_vm._v("Resume")])],1)],1),_c(VRow,{attrs:{"align-content-md":"center"}},[_c(VCol,{attrs:{"cols":"12","md":"6"}},[_vm._v(" Details du Client: "),_c('br'),_c('p',[_c('span',[_vm._v("Date Anniversaire")]),_vm._v(" :"),_c('strong',[_vm._v(_vm._s(_vm.customer.cust_birthday))])]),_c('p',[_c('span',[_vm._v("Lieu de Naissance")]),_vm._v(" :"),_c('strong',[_vm._v(_vm._s(_vm.customer.cust_birth_place))])]),_c('p',[_c('span',[_vm._v("Nom du pere")]),_vm._v(" :"),_c('strong',[_vm._v(_vm._s(_vm.customer.cust_father_name))])]),_c('p',[_c('span',[_vm._v("Nom de la mere")]),_vm._v(" :"),_c('strong',[_vm._v(_vm._s(_vm.customer.cust_mother_name))])]),_c('p',[_c('span',[_vm._v("Nom de caresse")]),_vm._v(" :"),_c('strong',[_vm._v(_vm._s(_vm.customer.cust_pseudonym))])]),_c('p',[_c('span',[_vm._v("Pays")]),_vm._v(" :"),_c('strong',[_vm._v(_vm._s(_vm.customer.cust_country))])]),_c('p',[_c('span',[_vm._v("Ville")]),_vm._v(" :"),_c('strong',[_vm._v(_vm._s(_vm.customer.cust_city))])]),_c('p',[_c('span',[_vm._v("Date d'expiration de la piece")]),_vm._v(" :"),_c('strong',[_vm._v(_vm._s(_vm.customer.cust_id_expiration_date))])]),_c('p',[_c('span',[_vm._v("Reference de la piece")]),_vm._v(" :"),_c('strong',[_vm._v(_vm._s(_vm.customer.cust_reference_id))])]),_c('p',[_c('span',[_vm._v("Date d'entre en cote d'ivoire")]),_vm._v(" :"),_c('strong',[_vm._v(_vm._s(_vm.customer.cust_date_of_entering_ivory_coast))])])]),_c(VCol,{attrs:{"cols":"12","md":"6"}},[_vm._v(" Details du Client: "),_c('br'),_c('p',[_c('span',[_vm._v("Civilite")]),_vm._v(" :"),_c('strong',[_vm._v(_vm._s(_vm.customer.cust_sexe))])]),_c('p',[_c('span',[_vm._v("Nom")]),_vm._v(" :"),_c('strong',[_vm._v(_vm._s(_vm.customer.cust_lastname))])]),_c('p',[_c('span',[_vm._v("Prenom")]),_vm._v(" :"),_c('strong',[_vm._v(_vm._s(_vm.customer.cust_firstname))])]),_c('p',[_c('span',[_vm._v("Nationalite")]),_vm._v(" :"),_c('strong',[_vm._v(_vm._s(_vm.customer.cust_nationality))])]),_c('p',[_c('span',[_vm._v("Contact")]),_vm._v(" :"),_c('strong',[_vm._v(_vm._s(_vm.customer.cust_contact))])]),_c('p',[_c('span',[_vm._v("Piece")]),_vm._v(" :"),_c('strong',[_vm._v(_vm._s(_vm.customer.cust_type_id))])]),_c('p',[_c('span',[_vm._v("Email")]),_vm._v(" :"),_c('strong',[_vm._v(_vm._s(_vm.customer.cust_email))])]),_c('p',[_c('span',[_vm._v("Profession")]),_vm._v(" :"),_c('strong',[_vm._v(_vm._s(_vm.customer.cust_job))])]),_c('p',[_c('span',[_vm._v("Domicile")]),_vm._v(" :"),_c('strong',[_vm._v(_vm._s(_vm.customer.cust_place_residence))])])])],1),_c(VRow,[_c(VCol,{attrs:{"cols":"12","md":"6"}},[_c(VBtn,{attrs:{"color":"primary"},on:{"click":function($event){_vm.e2 = 2}}},[_vm._v(" Precedent ")])],1),_c(VCol,{attrs:{"cols":"12","md":"6"}},[_c(VBtn,{staticStyle:{"margin-left":"1rem","margin-right":"1rem"},attrs:{"color":"primary"},on:{"click":_vm.modifiedCustomer}},[_vm._v(" Modifier ")])],1)],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }